var map = {
	"./Selamat_Pengantin_Baru-Anita_Sarawak.mp3": "1957",
	"./Selamat_Pengantin_Baru-Saloma.mp3": "d3eb",
	"./Selamat_Pengantin_Baru-Wann.mp3": "b3ac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e0ae";